import { render, staticRenderFns } from "./highlighted_products.vue?vue&type=template&id=10345a82&"
import script from "./highlighted_products.vue?vue&type=script&lang=js&"
export * from "./highlighted_products.vue?vue&type=script&lang=js&"
import style0 from "./highlighted_products.vue?vue&type=style&index=0&id=10345a82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports